import Commentreply from "../../commentreply/Commentreply"; 

const CommentList = ({ 
    isLoading, 
    error, 
    rootComments, 
    allComments, 
    queryClient, 
    currentUser, 
    postId 
}) => {

    if (isLoading) return <div className="loading">Loading comments...</div>;
    
    if (error) return <div className="error">Something went wrong loading comments.</div>;

    if (rootComments.length === 0) return <div className="no-comments">Be the first to comment!</div>;

    return (
        <div className="comment-list">
            {rootComments.map((comment) => (
                <Commentreply
                    key={comment.id}
                    comment={comment}        
                    queryClient={queryClient}
                    currentUser={currentUser}
                    postId={postId}
                />
            ))}
        </div>
    );
};

export default CommentList;